import { useState, useEffect } from 'react';

// Import helpers
import { obfuscate, deobfuscate } from 'helpers/localstorage';

const DEFAULT_CONFIG = { shouldObfuscate: false, type: localStorage };

// Hook to mimic useState but with localStorage
// shouldObfuscate - set plain and readable values or make them unreadable/hidden
const useBrowserStorage = (key, defaultValue, config) => {
	const { shouldObfuscate, type } = {
		...DEFAULT_CONFIG,
		...config
	};
	const [value, setValue] = useState(() => {
		try {
			if (shouldObfuscate) {
				const value = type?.getItem(key);
				if (Boolean(value)) return JSON.parse(deobfuscate(value));
				return defaultValue;
			}
			return JSON.parse(type?.getItem(key) || String(defaultValue));
		} catch (error) {
			return defaultValue;
		}
	});

	useEffect(() => {
		if (shouldObfuscate) {
			const valueToStore = obfuscate(value);
			type.setItem(key, valueToStore);
		} else {
			type.setItem(key, JSON.stringify(value));
		}
		//eslint-disable-next-line
	}, [value, key]);

	const clear = () => type.removeItem(key);

	return [value, setValue, clear];
};

export default useBrowserStorage;
